import { getDatabase, ref, set, update, get, child  } from 'firebase/database';
import { firebaseApp } from '../../config/firebase';
import { minify } from "html-minifier-terser";
import LZString from "lz-string";

export async function getContentByPageId(pageId) {
  const db = getDatabase(firebaseApp);
  const contentRef = ref(db, `content/${pageId}`);

  try {
    const snapshot = await get(contentRef);
    if (!snapshot.exists()) return [];

    const data = snapshot.val();

    return Object.keys(data).map((key) => {
      const section = data[key];
      // Decompress content
      const decompressedContent = section.contentData
        ? LZString.decompressFromUTF16(section.contentData)
        : "";
      return { Id: key, ...section, contentData: decompressedContent };
    });
  } catch (error) {
    console.error("Error fetching content:", error);
    return [];
  }
}

function getContent(pageName) {
    return new Promise(async (resolve, reject) => {
        try {
            // Join the array of content IDs into a comma-separated string for the URL
  

            const response = await fetch(`${process.env.NEXT_PUBLIC_REACT_APP_SERVER}/content?pageName=${pageName}`, {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    // "Authorization": "Bearer " + this.state.token
                }
            });

            const content = await response.json();

            if (response.ok) {
                resolve(content);
            } else {
                reject({ error: "Server error: "+ content.error || 'Failed to fetch content' });
            }
        } catch (error) {
            reject({ error: "Client error: "+ error.message || 'Network error' });
        }
    });
}

async function saveSectionContent(pageId, sectionId, htmlContent, extraFields = {}) {
  if (!pageId || !sectionId) {
    throw new Error("pageId and sectionId are required");
  }

  const db = getDatabase(firebaseApp);
  const sectionRef = ref(db, `content/${pageId}/${sectionId}`);

  // Compress HTML
  const compressedContent = LZString.compressToUTF16(htmlContent);

  const data = {
    bgColor: extraFields.bgColor || "",
    bgImg: extraFields.bgImg || "",
    bgOpacity: extraFields.bgOpacity || "",
    classes: extraFields.classes || "",
    contentData: compressedContent,
    youtubeUrl: extraFields.youtubeUrl || "",
  };

  const snapshot = await get(sectionRef);
  if (snapshot.exists()) {
    await update(sectionRef, data);
  } else {
    await set(sectionRef, data);
  }

  return true;
}

  function deleteContent(contentId,token) {
    return new Promise(async (resolve, reject) => {
      try {
        if(contentId){
          const response = await fetch(`${process.env.NEXT_PUBLIC_REACT_APP_SERVER}/content${contentId?`/${contentId}`:``}`, {
            method: "DELETE",
            credentials: "include", 
            headers: {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + token 
            }
          });
          const content = await response.json();
          if (response.ok) {
            resolve(content.contentId);
          } else {
            reject({error: content.error || 'Failed to Delete content'});
          }

        }else{
          reject({error: 'No ContentId'});
        }
      } catch (error) {
        reject({error: error.message || 'Network error'});
      }
    });
  }

  function uploadImageToServer(base64Image,token) {
    return new Promise(async (resolve, reject) => {
      try {
        let body = {
          base64Image
        }
        const response = await fetch(`${process.env.NEXT_PUBLIC_REACT_APP_SERVER}/content/imgUpload`, {
          method: "POST",
          credentials: "include", 
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + token 
          },
          body: JSON.stringify(body) 
        });
        if (!response.ok) {
          reject('Failed to upload image');
        }
  
      const result = await response.json();
      resolve(result.url) 
      } catch (error) {
        reject({error: error.message || 'Network error'});
      }
    });
  }

  function createPage(token,urlName,title,numSections) {
    return new Promise(async (resolve, reject) => {
      try {
        let body = {
          urlName,
          title,
          numSections:Number(numSections)
        }
        const response = await fetch(`${process.env.NEXT_PUBLIC_REACT_APP_SERVER}/content/page`, {
          method: "POST",
          credentials: "include", 
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + token 
          },
          body: JSON.stringify(body)  
        });
        const content = await response.json();
        if (response.ok) {
          resolve(content.contentId);
        } else {
          reject({error: content.error || 'Failed to post page'});
        }
      } catch (error) {
        reject({error: error.message || 'Network error'});
      }
    });
  }

  function clearCache(token,pageName="") {
    return new Promise(async (resolve, reject) => {
      try {
        let body = {
          pageName
        }
        const response = await fetch(`${process.env.NEXT_PUBLIC_REACT_APP_SERVER}/content/clearCache`, {
          method: "POST",
          credentials: "include", 
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + token 
          },
          body: JSON.stringify(body)  
        });
        const data = await response.json();
        if (response.ok) {
          resolve(data.message);
        } else {
          reject({error: content.error || 'Failed to post page'});
        }
      } catch (error) {
        reject({error: error.message || 'Network error'});
      }
    });
  }

  function transformSectionsToObject(sections) {
    return sections.reduce((acc, section) => {
      acc[section.Id] = section;
      return acc;
    }, {});
  }

export {
    getContent,
    saveSectionContent,
    uploadImageToServer,
    deleteContent,
    createPage,
    clearCache,
    transformSectionsToObject

}